import { MILISECONDS_TO_SECONDS } from 'constants/index';

export const getQuestionsTime = questions => {
  return questions.reduce((time, question) => {
    return time + question.time / MILISECONDS_TO_SECONDS;
  }, 0);
};
